export default [
    {
        title: '一、服务条款的确认与接纳',
        detail: [
            { content: '1.青岛同人建筑防火有限公司（以下简称“青岛同人”）运营同人消防服务机构监督管理平台，在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。' },
            { content: '2.本协议约定青岛同人与用户之间关于同人消防服务机构监督管理平台相关服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由青岛同人随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。在青岛同人修改协议条款后，如果用户不接受修改后的条款，请立即停止使用青岛同人提供的服务，用户继续使用青岛同人提供的服务将被视为接受修改后的协议。' },
        ]
    },
    {
        title: "二、注册信息与隐私保护",
        detail: [
            { content: "1.青岛同人帐号（即青岛同人用户ID）的所有权归青岛同人，用户按注册页面引导填写信息，阅读并同意本协议且完成全部注册程序后，即可获得青岛同人帐号并成为青岛同人用户。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实或更新不及时而引发的相关问题，青岛同人不负任何责任。您可以通过青岛同人帐号设置页面查询、更正您的信息，青岛同人帐号用户应当通过真实身份信息认证注册帐号，且用户提交的帐号名称、头像和简介等注册信息中不得出现违法和不良信息，同时，在注册后，青岛同人有权对用户的注册资料进行审查，对存在任何问题或怀疑的注册资料，青岛同人有权发出通知询问用户并要求用户做出解释、改正，如发现用户以虚假信息骗取帐号名称注册，或其帐号头像、简介等注册信息存在违法和不良信息的，青岛同人有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。" },
            { content: '2.青岛同人帐号包括帐户名称和密码，您可使用设置的帐户名称和密码登录青岛同人；在帐号使用过程中，为了保障您的帐号安全基于不同的终端以及您的使用习惯，我们可能采取不同的验证措施识别您的身份。例如您的帐户在新设备首次登录，我们可能通过密码加校验码的方式识别您的身份，验证方式包括但不限于短信验证码、服务使用信息验证。' },
            { content: '3.用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生所有行为负全部责任。由于帐号关联用户使用信息，仅当依法律法规、司法裁定或经青岛同人同意，并符合青岛同人规定的用户帐号转让流程的情况下，方可进行帐号的转让。' },
            { content: '4.因您个人原因导致的帐号信息遗失，如需找回青岛同人帐号信息，请按照青岛同人帐号找回要求提供相应的信息，并确保提供的信息合法真实有效，若提供的信息不符合要求，无法通过青岛同人安全验证，青岛同人有权拒绝提供帐号找回服务；若帐号的唯一凭证不再有效，青岛同人有权拒绝支持帐号找回。例如手机号二次出售，青岛同人可拒绝支持帮助找回原手机号绑定的帐号。' },
            { content: '5.当您使用青岛同人产品进行登录、支付等操作的时候，服务器会自动收取并记录一些必要的信息，如IP地址、服务访问异常信息、以及部分设备信息等，以保障您在使用青岛同人服务时账号登录和支付过程的安全，进而保护您的上网安全。您使用青岛同人的服务，即表示您同意青岛同人可以按照相关的隐私权政策处理您的个人信息。青岛同人可能会与合作伙伴共同向您提供您所要求的服务或者共同向您展示您可能感兴趣的内容。在信息为该项产品/服务所必须的情况下，您同意青岛同人可与其分享必要的信息。并且，青岛同人会要求其确保数据安全并且禁止用于任何其他用途。除此之外，青岛同人不会向任何无关第三方提供或分享信息。' },
            {
                content: '6.在如下情况下，青岛同人可能会披露您的信息:',
                detail: [
                    { content: '（1）事先获得您的授权；' },
                    { content: '（2）您使用共享功能；' },
                    { content: '（3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；' },
                    { content: '（4）为维护青岛同人的合法权益，例如查找、预防、处理欺诈或安全方面的问题；' },
                    { content: '（5）符合相关服务条款或使用协议的规定。' }

                ]
            },
            { content: '7.为更好地向用户提供服务，您同意青岛同人通过短信等形式向您发送相关商业性服务信息。' },
        ]
    },
    {
        title: '三、使用规则 ',
        detail: [
            {
                content: '1.用户在使用青岛同人服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为:',
                detail: [
                    {
                        content: '（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；',
                    },
                    {
                        content: "（2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；"
                    },
                    {
                        content: '（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；'
                    },
                    {
                        content: '（4）故意制作、传播计算机病毒等破坏性程序的；'
                    },
                    {
                        content: '（5）其他危害计算机信息网络安全的行为。'
                    }
                ]
            },
            {
                content: '2.用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿青岛同人与合作公司、关联公司，并使之免受损害。对此，青岛同人有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收青岛同人帐号、追究法律责任等措施。对恶意注册青岛同人帐号或利用青岛同人帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，青岛同人有权回收其帐号。同时，青岛同人公司会视司法部门的要求，协助调查。'
            },
            {
                content: "3.用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。"
            },
            {
                content: '4.用户不得违反《银行卡业务管理办法》使用银行卡，或利用信用卡套取现金（以下简称套现）。'
            },
            {
                content: '5.用户须对自己在使用青岛同人服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在青岛同人公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予青岛同人公司等额的赔偿。'
            }
        ],
    },
    {
        title: '四、青岛同人服务内容',
        detail: [
            {
                content: "1.除非本服务协议另有其它明示规定，青岛同人所推出的新产品、新功能、新服务，均受到本服务协议之规范。"
            },
            {
                content: "2.为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。"
            },
            {
                content: "3.鉴于网络服务的特殊性，用户同意青岛同人有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。青岛同人不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。"
            },
            {
                content: "4.免责声明：因以下情况造成网络服务在合理时间内的中断，青岛同人无需为此承担任何责任；",
                detail: [
                    { content: "（1）青岛同人需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，青岛同人保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。" },
                    { content: '（2）因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；' },
                    { content: '（3）用户的电脑软硬件和通信线路、供电线路出现故障的；' },
                    { content: '（4）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。' }
                ]
            },
            {
                content: "5.尽管有前款约定，青岛同人将采取合理行动积极促使服务恢复正常。"
            },
            {
                content: "6.本服务或第三人可提供与其它国际互联网上之网站或资源之链接。由于青岛同人无法控制这些网站及资源，您了解并同意，此类网站或资源是否可供利用，青岛同人不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料，青岛同人亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，青岛同人不承担任何责任。"
            },
            {
                content: '7.用户明确同意其使用青岛同人网络服务所存在的风险将完全由其自己承担。用户理解并接受下载或通过青岛同人服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。'
            },
            {
                content: "8.青岛同人有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，青岛同人对用户和任何第三人均无需承担任何责任。您同意青岛同人得基于其自行之考虑，因任何理由，包含但不限于青岛同人认为您已经违反本服务协议的文字及精神，终止您的密码、帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，青岛同人可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，青岛同人对您或任何第三人均不承担任何责任。"
            }
        ]
    },
    {
        title: "五、其他",
        detail: [
            { content: '1.本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。' },
            { content: '2.如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向青岛同人所在地青岛市人民法院提起诉讼。' },
            { content: '3.青岛同人未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。' },
            { content: '4.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。' }
        ]
    }
]